import { lazy } from 'react';

const IndicacaoPage = lazy(() => import('../pages'));

export const IndicacaoRoutes = [
  {
    path: '',
    element: <IndicacaoPage />,
  },
];
